
import AdminShoot from './components/admin/Shoot';
import AdminShoots from './components/admin/Shoots';
import Order from './components/admin/Order';
import Orders from './components/admin/Orders';
import auth from './support/Auth';
import Checkout from './components/Checkout';
import Login from './components/Login';
import Photo from './components/Photo';
import Shoot from './components/Shoot';
import Shoots from './components/Shoots';
import VueRouter from 'vue-router';

const routes = [
    {
        component: Login,
        name: 'login',
        path: '/account/login',
        meta: {
            guest: true,
            simple: true,
        },
    },
    {
        component: Login,
        name: 'forgot-password',
        path: '/account/forgot-password',
        meta: {
            guest: true,
            simple: true,
        },
    },
    {
        component: Login,
        name: 'reset-password',
        path: '/account/reset-password',
        meta: {
            guest: true,
            simple: true,
        },
    },
    {
        component: Login,
        name: 'setup',
        path: '/account/setup',
        meta: {
            guest: true,
            simple: true,
        },
    },
    {
        component: Shoots,
        name: 'shoots',
        path: '/',
        meta: {
            simple: true,
        },
    },
    {
        component: Shoot,
        name: 'shoot',
        path: '/shoots/:id',
        props: true,
        children: [
            {
                component: Photo,
                name: 'photo',
                path: 'photo/:photo_id',
                props: true,
            },
        ],
    },
    {
        component: AdminShoots,
        name: 'admin.shoots',
        path: '/admin/shoots',
        meta: {
            auth: true,
            superuser: true,
        },
        children: [
            {
                component: AdminShoot,
                name: 'admin.shoot.create',
                path: 'create',
                meta: {
                    auth: true,
                    superuser: true,
                },
            },
            {
                component: AdminShoot,
                name: 'admin.shoot',
                path: ':id',
                props: true,
                meta: {
                    auth: true,
                    superuser: true,
                },
            },
        ],
    },
    {
        component: Orders,
        name: 'admin.orders',
        path: '/admin/orders',
        meta: {
            auth: true,
            superuser: true,
        },
        children: [
            {
                component: Order,
                name: 'admin.order',
                path: ':id',
                props: true,
                meta: {
                    auth: true,
                    superuser: true,
                },
            },
        ],
    },
    {
        component: Checkout,
        name: 'checkout',
        path: '/checkout',
        meta: {
            simple: true,
        },
    },
];

const router = new VueRouter(
    {
        mode: 'history',
        routes,
    }
);

// authenticate middleware
router.beforeEach( ( to, from, next ) => {
    // route requires authentication
    if( to.matched.some( record => record.meta.auth === true ) ) {
        if( ! auth.check ) {
            next( { name: 'login', params: { redirect: to.fullPath } } );
        } else if( to.matched.some( record => record.meta.superuser ) && auth.user && ( auth.user.superuser !== true && auth.user.superuser !== 1 ) ) {
            next( { name: 'shoots' } );
        } else {
            next();
        }
    // route requires that user is a guest
    } else if( to.matched.some( record => record.meta.guest === true ) ) {
        if( auth.check ) {
            next( { name: 'shoots' } );
        } else {
            next();
        }
    // route request neither authenticated or guest users
    } else {
        next();
    }
});

export default router;
